import React from "react";
import { arrayOf, shape, string } from "prop-types";
import {
	ShareDownloadsParagraph,
	ShareDownloadsParagraphWrapper,
} from "@insightfulscience/atomic-react/r1/molecules/ShareDownloads";
import { useLocale } from "@insightfulscience/i18";

const ShareDownloadsMinVersion = ({ items }) => {
	const downloads = React.useMemo(
		() => new Map(items.map(item => [item.os, item])),
		[items], //
	);
	const [t] = useLocale("share-downloads-links");

	return (
		<>
			<ShareDownloadsParagraphWrapper>
				<ShareDownloadsParagraph color="black--20">
					*{" "}
					{t(`${downloads.get("mac").os.toUpperCase()}.REQUIREMENTS`, {
						version: downloads.get("mac").minOSVersion,
						name: downloads.get("mac").minOSName,
					})}
					,{" "}
					{t(`${downloads.get("windows").os.toUpperCase()}.REQUIREMENTS`, {
						version: downloads.get("windows").minOSVersion,
						name: downloads.get("windows").minOSName,
					})}
				</ShareDownloadsParagraph>
			</ShareDownloadsParagraphWrapper>
		</>
	);
};

ShareDownloadsMinVersion.propTypes = {
	items: arrayOf(
		shape({
			os: string,
			id: string,
			minOSVersion: string,
			minOSName: string,
			downloadLink: string,
		}),
	).isRequired,
};

export default ShareDownloadsMinVersion;
